import { Car } from '@lib/azgaz-ui/connect';

const formatBrand = (brand: Car['brand']) => {
  return brand.charAt(0).toUpperCase() + brand.slice(1);
};

export default formatBrand;
